import { render, staticRenderFns } from "./interact-solid.vue?vue&type=template&id=63af8bfa"
import script from "./interact-solid.vue?vue&type=script&lang=js"
export * from "./interact-solid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports